var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "attaUpload" }, [
    !_vm.isRole
      ? _c("div", { staticClass: "upload" }, [
          _c(
            "div",
            { staticClass: "sel" },
            [
              _c(
                "Poptip",
                {
                  attrs: {
                    trigger: "hover",
                    "word-wrap": "",
                    width: "400",
                    content: "",
                    transfer: "",
                  },
                },
                [
                  _c("Icon", {
                    staticClass: "icon",
                    attrs: { type: "ios-alert-outline" },
                  }),
                  _vm._v(" "),
                  _vm.tableName == "CL_C_VI_BASIC_COMMIT"
                    ? _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _c("p", [_vm._v("各节点必传附件说明：")]),
                          _vm._v(" "),
                          _c("p", { staticStyle: { "line-height": "1.5" } }, [
                            _vm._v(
                              "【基础资料提交】：店铺设计申请登记表、测场CAD标准文件、店铺勘查照片、签字版楼层落位图；"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [_vm._v("【平面图设计】：平面图终稿；")]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("【成套图设计】：成套图终稿、灯位图；"),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("【装修预算-空调】：装修预算表-空调；"),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "【预算审核-空调】：装修预算表-空调-确认版；"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("【装修预算-安防】：装修预算表-安防；"),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "【预算审核-安防】：装修预算表-安防-确认版；"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("【装修预算-消防】：装修预算表-消防；"),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "【预算审核-消防】：装修预算表-消防-确认版；"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticStyle: { "line-height": "1.5" } }, [
                            _vm._v(
                              "【装修预算-基装】：装修预算表-基装、新建隔墙图-基装、商场装修材料要求-基装；"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "【预算审核-基装】：装修预算表-基装-确认版；"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("【配货单确认】：道具配货单、灯具配货单；"),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "【供应商分配(选填)】：道具配货单-修订版、灯具配货单-修订版；"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [_vm._v("【省区验收】：验收照片、验收单；")]),
                        ]
                      )
                    : _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _c("p", [_vm._v("各节点必传附件说明：")]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "基础资料提交：店铺设计申请登记表、测场CAD标准文件、店铺勘查照片、签字版楼层落位图；"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "平面图设计：平面图终稿、灯位图、道具配货单、灯具配货单；"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [_vm._v("成套图设计：成套图终稿；")]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "装修施工：施工/效果图、装修预算表、装修变更单；"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("省区验收：验收报告、验收单、决算单；"),
                          ]),
                        ]
                      ),
                ],
                1
              ),
              _vm._v(" "),
              _c("label", [_vm._v("附件上传项 : ")]),
              _vm._v(" "),
              _c(
                "Select",
                {
                  attrs: { transfer: "", clearable: "" },
                  model: {
                    value: _vm.selectData,
                    callback: function ($$v) {
                      _vm.selectData = $$v
                    },
                    expression: "selectData",
                  },
                },
                _vm._l(_vm.uploadItem, function (item, index) {
                  return _c(
                    "Option",
                    { key: index, attrs: { value: item.limitval } },
                    [_vm._v(_vm._s(item.limitdesc))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.uplShow
            ? _c(
                "div",
                { staticClass: "upl" },
                [
                  _c("label", [_vm._v("附件上传 : ")]),
                  _vm._v(" "),
                  _c(
                    "Upload",
                    {
                      attrs: {
                        multiple: "",
                        action: "/p/cs/batchUpload",
                        name: "files",
                        accept: _vm.acceptFile,
                        "on-success": _vm.onSuccess,
                        "on-error": _vm.onError,
                        "on-remove": _vm.onRemove,
                        data: _vm.uplData,
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "uplFile" },
                        [
                          _c("Icon", { attrs: { type: "md-cloud-upload" } }),
                          _vm._v("上传附件\n        "),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isRole
      ? _c(
          "div",
          { staticClass: "pageNation" },
          [
            _c("Page", {
              attrs: {
                total: _vm.page.total,
                "show-sizer": "",
                "page-size-opts": _vm.page.pageSizeOpts,
                current: _vm.page.current,
                "page-size": _vm.page.pageSize,
              },
              on: {
                "on-change": _vm.pageChange,
                "on-page-size-change": _vm.pageSizeChange,
              },
            }),
            _vm._v(" "),
            _vm.button_show
              ? _c("div", { staticClass: "button" }, [
                  _c(
                    "span",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.save({ detail: { a: "不能为空", b: 2 } })
                        },
                      },
                    },
                    [_vm._v("【保存】")]
                  ),
                  _vm._v(" "),
                  _c("span", { on: { click: _vm.delItem } }, [
                    _vm._v("【删除明细】"),
                  ]),
                ])
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table" },
      [
        _c("Table", {
          attrs: {
            columns: _vm.tableConfig.columns,
            data: _vm.tableConfig.data,
          },
          on: { "on-selection-change": _vm.onSelectChange },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }